import { render } from "./MagnifyMinusOutlineIcon.vue?vue&type=template&id=45121da4"
import script from "./MagnifyMinusOutlineIcon.vue?vue&type=script&lang=js"
export * from "./MagnifyMinusOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__